export default __webpack_public_path__ + "c47be42db748b2f11db798e2bc4af47e.png";